import Notifications from 'views/components/common/Notifications/Notifications';

export default Notifications;
